import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import ActionsBarPres from '../presentational/ActionsBarPres';
import { SERVICEINIT_LANDING_URL } from 'src/constants/constants.js';
import { transformFormValues } from 'src/helpers';
import { CREATEORGANIZER_PAGESTATES } from 'src/constants/constants';
import { withSnackbar } from 'notistack';
import { SI_MENU_PAGESTATES } from 'src/constants/constants';
import { updateMenu, updateMenuIndex, setServiceInitPage, toggleSpinner } from 'src/ui/features/ServiceInit/state/serviceInitActions';
import { saveNewServiceInitiation } from 'src/services/serviceinit.service';
import { fnIsDefaultOldView } from 'src/helpers/commonFunctions';

const isMenuComplete = status => status === SI_MENU_PAGESTATES.COMPLETE || status === SI_MENU_PAGESTATES.CURRENT_COMPLETE;
const isMenuNotComplete = status => status === SI_MENU_PAGESTATES.CURRENT_NOT_COMPLETE;

class ActionsBarContainer extends Component {
  static propTypes = {
    enqueueSnackbar: PropTypes.func.isRequired,
  };

  static defaultProps = {
    formValues: {},
  };

  state = {
    isNextClicked: false,
    showModal: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.menu.length !== prevProps.menu.length && this.state.isNextClicked) {
      const { menu, menuIndex, push } = this.props;
      if (menu.length && menuIndex !== menu.length - 1) {
        const { url } = menu[menuIndex + 1];
        push(url);
      }
    }
  }

  handlePrevPage = () => {
    const { menu, menuIndex, push } = this.props;
    let newMenuIndex = menuIndex;

    if (menuIndex >= 0) {
      newMenuIndex = menuIndex - 1;
    }

    const { url, pageId } = menu[newMenuIndex];

    this.handleSave(false, true, pageId, () => {
      push(url);
      this.props.updateMenuIndex(newMenuIndex);
    });
    if (this.props.updateValidationErrorState) {
      this.props.updateValidationErrorState();
    }
  };

  handleNextPage = () => {
    this.setState({ isNextClicked: true });

    const { menu, menuIndex, push } = this.props;
    let newMenuIndex = menuIndex;

    if (menuIndex !== menu.length - 1) {
      newMenuIndex = menuIndex + 1;
    }

    const { url, pageId } = menu[newMenuIndex];

    this.handleSave(false, true, pageId, () => {
      push(url);
      this.props.updateMenuIndex(newMenuIndex);
    });
  };

  handleSaveAndClose = () => {
    this.setState({ isNextClicked: true });

    const { enqueueSnackbar, menu, menuIndex, push } = this.props;
    let newMenuIndex = menuIndex;

    if (menuIndex !== menu.length - 1) {
      newMenuIndex = menuIndex + 1;
    }

    const { url, pageId } = menu[newMenuIndex];

    this.handleSave(false, true, pageId, () => {
      enqueueSnackbar('Saved Successful', { variant: 'success' });
      // push(url);
      if (fnIsDefaultOldView()) {
        push(url);
        this.props.push(SERVICEINIT_LANDING_URL);
      } else window.location.href = SERVICEINIT_LANDING_URL;
      // this.props.push(SERVICEINIT_LANDING_URL);
    });
  };

  handleSave = async (showNotification = true, isDraft = true, pageId = 0, callback = () => {}) => {
    // there's nothing to save on a menu page. we'll revisit this later
    if (this.props.noSave) {
      return callback('');
    }

    this.props.toggleSpinner(true);

    const { enqueueSnackbar, routeParams, updateMenu, setServiceInitPage } = this.props;
    const { formValues, isFormComplete } = this.props.formValues;

    const { organizerInstanceId, entityId, yearTypeId, organizerTypeId, sourceTableId } = this.props.page;
    const pageState = isFormComplete ? CREATEORGANIZER_PAGESTATES.COMPLETE : CREATEORGANIZER_PAGESTATES.CURRENT_NOT_COMPLETE;

    const orgOptions = {
      entityId,
      organizerInstanceId,
      organizerTypeId,
      yearTypeId,
      pageId,
      pageSourceId: sourceTableId,
      languageId: 1,
      pageState,
      isDrafted: isDraft,
      isSubmitted: false,
      ...transformFormValues(formValues),
    };

    const result = await saveNewServiceInitiation(orgOptions);
    this.props.toggleSpinner(false);

    if (result && result.success) {
      if (isDraft) {
        updateMenu(result.menus, routeParams);
        setServiceInitPage(result);
      }

      if (showNotification) {
        enqueueSnackbar('Saved Successful', { variant: 'success' });
      }
    } else {
      if (result && result.errorCode === 'INVALID_DAG') {
        enqueueSnackbar('Data Access Group is invalid', { variant: 'error' });
        return;
      }
      if (result.error) throw Error(result.error.message);
    }
    callback(orgOptions);
  };

  handleSubmit = () => {
    this.setState({ isSubmittingServiceInitiation: true });
    const { menu, menuIndex } = this.props;
    const { pageId } = menu[menuIndex];

    this.handleSave(false, false, pageId, async orgNew => {
      this.props.showServiceDetails(orgNew);
    });
  };

  handleToggleModal = () => {
    this.setState(prevState => ({ showModal: !prevState.showModal }));
  };

  handleCancel = () => {
    if (fnIsDefaultOldView()) this.props.push(SERVICEINIT_LANDING_URL);
    else window.location.href = SERVICEINIT_LANDING_URL;
  };

  checkSubmitEnabled = () => {
    const { formValues, menu, menuIndex, page } = this.props;

    if (page.isSubmitted === true) {
      return false;
    }

    let isSubmitEnabled = true;

    menu.forEach((menuItem, index) => {
      if (
        menuItem.pageId !== 0 &&
        ((!isMenuComplete(menuItem.pageState) && index !== menuIndex) ||
          (index === menuIndex &&
            (menuItem.menuName === 'generalinformation_tab' ? !formValues.isFormComplete : isMenuNotComplete(menuItem.pageState))))
      ) {
        isSubmitEnabled = false;
      }
    });

    return isSubmitEnabled;
  };

  checkSaveDraftEnabled = () => {
    const { formValues, page } = this.props;
    let isElementUpdated = formValues.formValues ? Object.values(formValues.formValues.dataRequests).every(x => x === '') : true;
    if (page.entityId !== '00000000-0000-0000-0000-000000000000' || !isElementUpdated) {
      return false;
    }
    return true;
  };

  //  toggleConfirmSubmitDialog = () => this.setState(prevState => ({ isConfirmSubmitDialogOpen: !prevState.isConfirmSubmitDialogOpen }));

  render() {
    const { menuIndex, menu, formValues, validationError, isEmployeeSelected, isDraft } = this.props;

    return (
      <ActionsBarPres
        showModal={this.state.showModal}
        onSubmit={this.handleSubmit}
        onCancel={this.handleCancel}
        onToggleModal={this.handleToggleModal}
        onSave={this.handleSave}
        onPrevPage={this.handlePrevPage}
        onNextPage={this.handleNextPage}
        onSaveAndClose={this.handleSaveAndClose}
        isFirstPage={menuIndex === 0}
        isLastPage={menuIndex === menu.length - 1}
        isSubmitDisabled={!this.checkSubmitEnabled() || validationError}
        isNextDisabled={formValues ? !formValues.isFormComplete || validationError : null}
        // isConfirmSubmitDialogOpen={this.state.isConfirmSubmitDialogOpen}
        // toggleConfirmSubmitDialog={this.toggleConfirmSubmitDialog}
        isSubmittingServiceInitiation={this.state.isSubmittingServiceInitiation}
        isSubmitted={this.props.page.isSubmitted}
        isEmployeeSelected={isEmployeeSelected}
        isDraft={isDraft}
        isSaveDraftEnabled={this.checkSaveDraftEnabled()}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => ({
  page: state.serviceInit.page,
  menu: state.serviceInit.menu,
  menuIndex: state.serviceInit.menuIndex,
  isTablet: state.browser.greaterThan.small && state.browser.is.medium,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
});

const mapDispatchToProps = {
  push,
  updateMenu,
  updateMenuIndex,
  toggleSpinner,
  setServiceInitPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ActionsBarContainer));
